import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { find, isEmpty } from 'lodash';
import { Radio, Row, Col, Slider, Divider, Popover, Button, Avatar, Select } from 'antd';
import { ThunderboltTwoTone } from '@ant-design/icons';
import { msalInstance } from "../../../index";

import { saveAppSettings, loadLabels, setDebugLabels } from '../actions';
import * as constants from '../constants';

import currentuser from '../../currentuser';
import globalappstate from '../../globalappstate';


const Option = Select.Option;

const marks = {
    30: '30%',
    40: '40%',
    50: '50%',
    60: '60%',
};

class Settings extends Component {


    langChange = (e) => {
        let appsettings = { ...this.props.appsettings };
        appsettings.lang = parseInt(e.target.value, 10);
        this.props.saveAppSettings(appsettings);
        this.props.loadLabels();
    }

    onChange = (value) => {
        let appsettings = { ...this.props.appsettings };
        appsettings.detailwidth = value;
        this.props.saveAppSettings(appsettings);
    }

    onSetDebugLabels = () => {
        this.props.setDebugLabels();
    }
    logout = () => {
        console.log('logout');
        msalInstance.logoutRedirect();
    }

     render() {
        const offset = 1;
        if (this.props.labels) {
            console.log(this.props.labels);
        }

        return (
            <div style={{ width: 500 }}>
                <Row>
                    <Col offset={this.props.mobile ? 2 : 16} span={8}>
                        <Link to={'/quit'}>
                            <Button type="logout" onClick={this.logout} > Afmelden / Sign out </Button>
                        </Link>
                    </Col>
                </Row>
                <Row>
                    <Col offset={offset} >
                        <Row>
                            {!this.props.mobile &&
                                <Col span={5}>
                                    <Avatar size={96} src={`https://mdmapi.ballast-nedam.nl/api/prs/image/user?width=900&height=120&id=${this.props.currentuser.idUser}`} />
                                </Col>
                            }
                            <Col offset={offset} span={17 - offset}>
                                <span style={{ display: 'inline-block', fontWeight: 'bold', fontSize: 'larger' }}>
                                    {this.props.currentuser.displayname}
                                </span>
                                <span style={{ display: 'inline-block' }}>
                                    {this.props.currentuser.email}
                                </span>
                            </Col>
                        </Row>
                    </Col>

                </Row>
                <Divider orientation="left">Taal / Language:</Divider>
                <Row>
                    <Popover content="Set the ui language for this application / Stel de taal van de gebruikers interface in voor deze applicatie" trigger="hover">
                        <Col offset={offset} span={22}>
                            <Radio.Group value={this.props.appsettings.lang.toString()} onChange={this.langChange}>
                                <Radio.Button value="1043">NL</Radio.Button>
                                <Radio.Button value="1033">EN</Radio.Button>
                            </Radio.Group>
                            {this.props.userisadmin &&
                                <Button style={{ margin: 15 }} type="primary" onClick={this.onSetDebugLabels} >
                                    <ThunderboltTwoTone />Debug Labels
                                </Button>
                            }
                        </Col>
                    </Popover>
                </Row>
                {!this.props.mobile &&
                    <>
                        <Divider orientation="left">Details paneel breedte / Details pane width:</Divider>
                        <Row>
                            <Popover content="Set the default width of the left pane / Stel de standaard breedte in van het linker paneel" trigger="hover">
                                <Col offset={offset} span={22}>
                                    <Slider marks={marks} step={null} min={25} max={100} onChange={this.onChange} value={this.props.appsettings.detailwidth} />
                                </Col>
                            </Popover>
                        </Row>
                    </>
                }
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        appsettings: state[constants.NAME].appsettings,
        currentuser: state[currentuser.constants.NAME],
        picklists: globalappstate.selectors.allPicklists(state),
    };
}

export default connect(mapStateToProps, {
    saveAppSettings,
    loadLabels,
    setDebugLabels
})(Settings);